import React from "react";
import classes from './iconsComponent.module.scss'

const IconsComponent = () => {
  return (
    <div className={classes.iconsPage}>
      <div className={classes.iconPage__title}>
        <h1>Icons Style Guide - Ionicons - Outlined</h1>
        <p>Premium designed icons for use in web, iOS, Android, and desktop apps. Support for SVG and web font. Completely open source, MIT licensed and built by the Ionic Framework team.</p>
        <p className={classes.styleInstruction}>For usage, kindly check the Styles Usage Section</p>
      </div>
      <div className={classes.iconPage__container}>
        <ion-icon size="large" name="accessibility-outline"></ion-icon>
        <ion-icon size="large" name="add-outline"></ion-icon>
        <ion-icon size="large" name="add-circle-outline"></ion-icon>
        <ion-icon size="large" name="airplane-outline"></ion-icon>
        <ion-icon size="large" name="alarm-outline"></ion-icon>
        <ion-icon size="large" name="albums-outline"></ion-icon>
        <ion-icon size="large" name="alert-outline"></ion-icon>
        <ion-icon size="large" name="alert-circle-outline"></ion-icon>
        <ion-icon size="large" name="american-football-outline"></ion-icon>
        <ion-icon size="large" name="analytics-outline"></ion-icon>
        <ion-icon size="large" name="aperture-outline"></ion-icon>
        <ion-icon size="large" name="apps-outline"></ion-icon>
        <ion-icon size="large" name="archive-outline"></ion-icon>
        <ion-icon size="large" name="arrow-back-outline"></ion-icon>
        <ion-icon size="large" name="arrow-back-circle-outline"></ion-icon>
        <ion-icon size="large" name="arrow-down-outline"></ion-icon>
        <ion-icon size="large" name="arrow-down-circle-outline"></ion-icon>
        <ion-icon size="large" name="arrow-forward-outline"></ion-icon>
        <ion-icon size="large" name="arrow-forward-circle-outline"></ion-icon>
        <ion-icon size="large" name="arrow-redo-outline"></ion-icon>
        <ion-icon size="large" name="arrow-redo-circle-outline"></ion-icon>
        <ion-icon size="large" name="arrow-undo-outline"></ion-icon>
        <ion-icon size="large" name="arrow-undo-circle-outline"></ion-icon>
        <ion-icon size="large" name="arrow-up-outline"></ion-icon>
        <ion-icon size="large" name="arrow-up-circle-outline"></ion-icon>
        <ion-icon size="large" name="at-outline"></ion-icon>
        <ion-icon size="large" name="at-circle-outline"></ion-icon>
        <ion-icon size="large" name="attach-outline"></ion-icon>
        <ion-icon size="large" name="backspace-outline"></ion-icon>
        <ion-icon size="large" name="bag-outline"></ion-icon>
        <ion-icon size="large" name="bag-add-outline"></ion-icon>
        <ion-icon size="large" name="bag-check-outline"></ion-icon>
        <ion-icon size="large" name="bag-handle-outline"></ion-icon>
        <ion-icon size="large" name="bag-remove-outline"></ion-icon>
        <ion-icon size="large" name="balloon-outline"></ion-icon>
        <ion-icon size="large" name="ban-outline"></ion-icon>
        <ion-icon size="large" name="bandage-outline"></ion-icon>
        <ion-icon size="large" name="bar-chart-outline"></ion-icon>
        <ion-icon size="large" name="barbell-outline"></ion-icon>
        <ion-icon size="large" name="barcode-outline"></ion-icon>
        <ion-icon size="large" name="baseball-outline"></ion-icon>
        <ion-icon size="large" name="basket-outline"></ion-icon>
        <ion-icon size="large" name="basketball-outline"></ion-icon>
        <ion-icon size="large" name="battery-charging-outline"></ion-icon>
        <ion-icon size="large" name="battery-dead-outline"></ion-icon>
        <ion-icon size="large" name="battery-full-outline"></ion-icon>
        <ion-icon size="large" name="battery-half-outline"></ion-icon>
        <ion-icon size="large" name="beaker-outline"></ion-icon>
        <ion-icon size="large" name="bed-outline"></ion-icon>
        <ion-icon size="large" name="beer-outline"></ion-icon>
        <ion-icon size="large" name="bicycle-outline"></ion-icon>
      </div>
    </div>
  );
};

export default IconsComponent;
